export const CREATE_MEETING = "CREATE_MEETING";
export const GET_ALL_MEETINGS = "GET_ALL_MEETINGS";
export const GET_ALL_INVITED_IN = "GET_ALL_INVITED_IN";
export const GET_MEETING = "GET_MEETING";
export const UPDATE_MEETING = "UPDATE_MEETING";
export const MINUTES_TEMPLATE = "MINUTES_TEMPLATE";
export const CREATE_MINUTES = "CREATE_MINUTES";
export const AVAILABLE_ROOM = "AVAILABLE_ROOM";
export const ERRORS = "ERRORS";
export const RESOURCER_LIST_ALL = "RESOURCER_LIST_ALL";
export const RESOURCER_LIST_ALL_ERROR = "RESOURCER_LIST_ALL_ERROR";
export const MEETING_LIST_ALL = "MEETING_LIST_ALL";
export const MEETING_LIST_ALL_ERROR = "MEETING_LIST_ALL_ERROR";
export const CREATE_DRAFT = "CREATE_DRAFT";
export const DRAFT_DETAILS = "DRAFT_DETAILS";
export const GET_ALL_DRAFTS = "GET_ALL_DRAFTS";
export const MINUTES_DETAILS = "MINUTES_DETAILS";
